// @flow

import PointLayer12WithSplices from './methods/PointLayer12WithSplices';

export default class TerminalBoxResource extends PointLayer12WithSplices {
    basePath: string = 'networks/terminal-boxes/';

    objectPath: string = 'networks/terminal-boxes/{ident}/';
}
